import { useState, useEffect, useRef } from 'react'

const REVIEWS = [
  {
    id: 1,
    title: 'Det var turen værd fra Aalborg',
    text: '“Vi har lige handlet bil hos Steen/ EK Biler. Hele forløbet gik perfekt. Fra prøvekørsel, finansering, og efterfølgende handel ugen efter. Meget fine brugte vogne de har dernede. Vi tog turen fra Aalborg for at handle med Steen. Utrolig flink mand. Ingen kryben udenom ifht alle de spørgsmål der blev stillet. Fornøjelse. Vi kommer gerne igen hvis der skal handles en anden gang.”',
    author: 'Finn Win',
    source: 'Kundeanmeldelse',
    rating: 5,
  },
  {
    id: 2,
    title: 'Meget god service',
    text: '“Jeg har lige købt mig en bil af Steen(EK biler) i går. Super fin og professionel oplevelse. Han tog min gamle bil i bytte uden problemer. Steen er super venlig og service minded. Kan kun sige gode ting fra min oplevelse igår.”',
    author: 'Nicklas Kristensen',
    source: 'Kundeanmeldelse',
    rating: 5,
  },
  {
    id: 3,
    title: 'Virkelig god oplevelse',
    text: '“Købte en nyere brugt bil og gav vores gamle i bytte, en virkelig positiv og tryg oplevelse, kan kun anbefale at købe bil hos Steen.”',
    author: 'Steen Larsen',
    source: 'Kundeanmeldelse',
    rating: 5,
  },
  {
    id: 4,
    title: 'Varm anbefaling herfra 👍',
    text: '“Varm anbefaling herfra👍 Vi købte en bil hos Steen (EK Biler) idag og gav vores gamle i bytte. Helt igennem en proffisionel oplevelse. Steen fremstår ærlig og tillidsfuld og det var en fornøjelse ikke at havne i et glashus med en masse smarte sælgere og tingel tangel😊”',
    author: 'Mikael Bruun',
    source: 'Kundeanmeldelse',
    rating: 5,
  },
  {
    id: 5,
    title: 'Kvalitet og god behandling',
    text: '“Super service og god kommunikation fra start til slut. Altid en fornøjelse at få serviceret bilen hos Steen på værkstedet i Hejnsvig.”',
    author: 'Henrik M.',
    source: 'Kundeanmeldelse',
    rating: 5,
  },
]

export default function ReviewsSlider() {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isHovered, setIsHovered] = useState(false)
  const [visibleCount, setVisibleCount] = useState(3)
  const total = REVIEWS.length

  // Dynamically adapt visible items based on viewport
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setVisibleCount(1)
      } else if (window.innerWidth < 1024) {
        setVisibleCount(2)
      } else {
        setVisibleCount(3)
      }
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const maxIndex = Math.max(0, total - visibleCount)

  const handleNext = () => {
    setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1))
  }

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev <= 0 ? maxIndex : prev - 1))
  }

  // Smooth sliding autoplay effect every 4.5 seconds (pauses on user hover)
  useEffect(() => {
    if (isHovered) return
    const timer = setInterval(() => {
      handleNext()
    }, 4500)
    return () => clearInterval(timer)
  }, [isHovered, maxIndex, visibleCount])

  // Calculate slide offset percentage
  const slidePercent = 100 / visibleCount

  return (
    <section className="py-16 bg-gray-50 text-gray-900 border-y border-gray-200 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header & Trust Score */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="inline-block px-3 py-1 bg-red-50 border border-red-200 text-[#e20019] text-xs font-bold uppercase tracking-[0.2em] mb-3">
              <i className="fa-solid fa-star text-[#e20019] mr-1.5" aria-hidden="true" />
              <span>Kundetilfredshed</span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl font-bold uppercase tracking-wide text-gray-900">
              Hvad siger vores kunder?
            </h2>
            <p className="text-gray-600 text-sm mt-1 max-w-xl">
              Vi lever af tilfredse kunder og ærlig rådgivning – uanset om du køber bil eller har din
              bil på værkstedet.
            </p>
          </div>

          {/* Rating Badge */}
          <div className="flex items-center gap-4 bg-white border border-gray-200 shadow-xs p-3.5 sm:p-4 shrink-0">
            <div className="text-3xl sm:text-4xl font-black font-display text-[#e20019]">4,6</div>
            <div>
              <div className="flex items-center gap-1 text-amber-400 text-sm">
                <i className="fa-solid fa-star" aria-hidden="true" />
                <i className="fa-solid fa-star" aria-hidden="true" />
                <i className="fa-solid fa-star" aria-hidden="true" />
                <i className="fa-solid fa-star" aria-hidden="true" />
                <i className="fa-solid fa-star-half-stroke" aria-hidden="true" />
              </div>
              <div className="text-xs text-gray-800 font-medium mt-0.5">
                Meget godt • 88 anmeldelser
              </div>
              <div className="text-[10px] text-gray-500">Kundeanmeldelser fra Auto-Trust</div>
            </div>
          </div>
        </div>

        {/* Sliding Autoplay Container */}
        <div
          className="relative overflow-hidden -mx-3"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div
            className="flex transition-transform duration-700 ease-in-out will-change-transform"
            style={{
              transform: `translateX(-${currentIndex * slidePercent}%)`,
            }}
          >
            {REVIEWS.map((review) => (
              <div
                key={review.id}
                className="w-full md:w-1/2 lg:w-1/3 shrink-0 px-3 flex flex-col"
              >
                <ReviewCard review={review} />
              </div>
            ))}
          </div>
        </div>

        {/* Slider Controls */}
        <div className="mt-8 flex items-center justify-between">
          {/* Indicators */}
          <div className="flex items-center gap-2">
            {Array.from({ length: maxIndex + 1 }).map((_, i) => (
              <button
                key={i}
                type="button"
                onClick={() => setCurrentIndex(i)}
                className={`h-2 rounded-full transition-all focus:outline-none focus:ring-1 focus:ring-red-500 ${
                  i === currentIndex ? 'w-8 bg-[#e20019]' : 'w-2 bg-gray-300 hover:bg-gray-400'
                }`}
                aria-label={`Gå til dias ${i + 1}`}
              />
            ))}
          </div>

          {/* Prev / Next Arrows */}
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={handlePrev}
              className="w-10 h-10 rounded-none bg-white border border-gray-300 hover:bg-gray-100 hover:border-gray-400 text-gray-800 shadow-xs flex items-center justify-center transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 cursor-pointer"
              aria-label="Forrige anmeldelse"
            >
              <i className="fa-solid fa-chevron-left text-sm" aria-hidden="true" />
            </button>
            <button
              type="button"
              onClick={handleNext}
              className="w-10 h-10 rounded-none bg-white border border-gray-300 hover:bg-gray-100 hover:border-gray-400 text-gray-800 shadow-xs flex items-center justify-center transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 cursor-pointer"
              aria-label="Næste anmeldelse"
            >
              <i className="fa-solid fa-chevron-right text-sm" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

function ReviewCard({ review }) {
  return (
    <div className="bg-white border border-gray-200 p-6 flex flex-col justify-between h-full shadow-xs hover:shadow-md hover:border-gray-300 transition-all">
      <div>
        {/* Stars & Quote Icon */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-1 text-amber-400 text-xs">
            {Array.from({ length: review.rating }).map((_, i) => (
              <i key={i} className="fa-solid fa-star" aria-hidden="true" />
            ))}
          </div>
          <i className="fa-solid fa-quote-right text-2xl text-gray-200" aria-hidden="true" />
        </div>

        <h3 className="font-bold text-gray-900 text-base mb-2">{review.title}</h3>
        <p className="text-gray-600 text-sm leading-relaxed mb-6">{review.text}</p>
      </div>

      <div className="pt-4 border-t border-gray-100 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-full bg-red-50 border border-red-200 text-[#e20019] flex items-center justify-center font-bold text-xs uppercase">
            {review.author.charAt(0)}
          </div>
          <div>
            <div className="font-semibold text-gray-900 text-sm">{review.author}</div>
            <div className="text-[11px] text-gray-500">{review.source}</div>
          </div>
        </div>
        <div className="flex items-center gap-1 text-emerald-700 text-xs font-medium">
          <i className="fa-solid fa-shield-halved text-[11px]" aria-hidden="true" />
          <span>Verificeret</span>
        </div>
      </div>
    </div>
  )
}
